import { Component, Input, OnInit } from '@angular/core';
import { BookingEditorService } from '../../../services/booking-editor/booking-editor.service';
import { ModalService } from '../../../services/gui/modal/modal.service';
import { DomHelper } from '@bryntum/scheduler/scheduler.module.js';

@Component({
  selector: 'sb-commercial-conflict-list',
  templateUrl: './sb-commercial-conflict-list.component.html',
  styleUrls: ['./sb-commercial-conflict-list.component.scss'],
  standalone: false,
})
export class SbCommercialConflictListComponent implements OnInit {
  @Input() type: string;
  @Input() templateId: string;
  targetElement: HTMLElement[];

  constructor(
    public bookingEditorService: BookingEditorService,
    private modal: ModalService
  ) {}

  ngOnInit(): void {}

  scrollToView(record) {
    switch (this.type) {
      case 'modal': {
        this.modal.close(this.templateId);
        break;
      }
      case 'dropdown': {
        break;
      }
    }
    this.bookingEditorService.scheduler.schedulerInstance
      .scrollEventIntoView(record, {
        animate: true,
        focus: true,
        block: 'center',
      })
      .then(() => {
        if (!this.targetElement) {
          this.targetElement = this.bookingEditorService.scheduler.schedulerInstance.getElementsFromEventRecord(record);
          DomHelper.addClasses(this.targetElement[0], ['commercialEventHighlight']);
          setTimeout(() => {
            DomHelper.removeClasses(this.targetElement[0], ['commercialEventHighlight']);
            this.targetElement = null;
          }, 3000);
        }
      });
  }
}
